import React from "react";
import { useTranslation } from "react-i18next";

import "./OnboardingModal.css";

export default function OnboardingModal({
  sectionId = "assistant",
  role = "patient",
  locale = "fr",
  onClose,
}) {
  const { t } = useTranslation("assistantAi");
  const normalizedRole = role === "doctor" ? "doctor" : "patient";
  const normalizedLocale = String(locale || "").toLowerCase().startsWith("ar")
    ? "ar"
    : String(locale || "").toLowerCase().startsWith("en")
      ? "en"
      : "fr";
  const normalizedSection = ["gestion", "assistant", "agent"].includes(sectionId) ? sectionId : "assistant";
  const content =
    t(`onboarding.${normalizedSection}.${normalizedRole}`, { lng: normalizedLocale, returnObjects: true }) ||
    t(`onboarding.${normalizedSection}.${normalizedRole}`, { lng: "fr", returnObjects: true });
  const isRtl = normalizedLocale === "ar";

  const handleClose = () => {
    try {
      localStorage.setItem(`ml_onboarding_${normalizedSection}_seen`, "true");
    } catch {
      // localStorage can be unavailable in private contexts.
    }
    onClose?.(normalizedSection);
  };

  return (
    <div className="ml-onboarding" role="dialog" aria-modal="true" dir={isRtl ? "rtl" : "ltr"}>
      <div className={`ml-onboarding__card ml-onboarding__card--${normalizedSection}`}>
        <button
          type="button"
          className="ml-onboarding__close"
          onClick={handleClose}
          aria-label={t("onboarding.close", { lng: normalizedLocale })}
        >
          x
        </button>

        <div className="ml-onboarding__icon" aria-hidden="true">{content.icon}</div>
        <h2>{content.title}</h2>
        <p>{content.description}</p>

        <ul>
          {content.features.map((feature) => (
            <li key={feature}>
              <span aria-hidden="true">✓</span>
              {feature}
            </li>
          ))}
        </ul>

        <button type="button" className="ml-onboarding__cta" onClick={handleClose}>
          {content.cta}
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </div>
  );
}
